import { render, staticRenderFns } from "./place-of-care.vue?vue&type=template&id=71f7dd9d&scoped=true"
import script from "./place-of-care.vue?vue&type=script&lang=js"
export * from "./place-of-care.vue?vue&type=script&lang=js"
import style0 from "./place-of-care.vue?vue&type=style&index=0&id=71f7dd9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f7dd9d",
  null
  
)

export default component.exports